import React, { FC, HTMLAttributes } from 'react';

import { Image, IImageProps } from 'components/Image/Image';
import { browserBreakpoints } from 'utils/breakpoints';
import { Asset } from 'services/cms/typesUtil';

type FlatResponsiveImageProps = Omit<IImageProps, 'src'> & {
  image?: Asset;
  mobileImage?: Asset;
  tabletImage?: Asset;
  pictureProps?: HTMLAttributes<HTMLElement>;
};

export const FlatResponsiveImage: FC<FlatResponsiveImageProps> = ({
  image,
  mobileImage,
  tabletImage,
  alt,
  pictureProps,
  ...props
}) => {
  if (!image) return null;
  return (
    <picture {...pictureProps}>
      {mobileImage && (
        <source
          media={`(max-width: ${tabletImage ? browserBreakpoints.mobile : browserBreakpoints.tablet}px)`}
          srcSet={mobileImage.file?.url}
          data-asset-id={mobileImage.id}
        />
      )}
      {tabletImage && (
        <source
          media={`(max-width: ${browserBreakpoints.tablet}px)`}
          srcSet={tabletImage.file?.url}
          data-asset-id={tabletImage.id}
        />
      )}
      <Image alt={alt || image.description || ''} src={image.file?.url} dataAssetId={image.id} {...props} />
    </picture>
  );
};
